import { TargetType } from '../utils/enums';
import request from '../utils/request';
import { Service } from '../types/app';
import { AxiosPromise } from 'axios';
import { Targets, TargetUser } from '@Policy/utils/types';

function getPolicyTargets(
  orgId: string,
  service: Service | string,
  targetType: TargetType,
  targetId: string,
  pagination: any,
  category?: number
) {
  // return category
  //   ? request({
  //       url: `users/orgs/${orgId}/services/${service}/targetTypes/${targetType}/targets/${targetId}?category=${category}`,
  //       method: 'post',
  //       data: pagination,
  //     })
  //   : request({
  //       url: `users/orgs/${orgId}/services/${service}/targetTypes/${targetType}/targets/${targetId}`,
  //       method: 'post',
  //       data: pagination,
  //     });

  const params = {
    targetType,
    ...pagination,
  };

  if (category) {
    // used for salesforce
    Object.assign(params, { category });
  }
  return request({
    url: `users/services/${service}/targets/${targetId}`,
    method: 'get',
    params,
    headers: {
      'x-org-id': orgId,
    },
  });
}

function getLocalAccountTargets(
  orgId: string,
  targetId: string,
  pagination: any
) {
  return request({
    url: `localAccounts/targetsTree/targets/${targetId}`,
    method: 'post',
    data: pagination,
    headers: {
      'x-org-id': orgId,
    },
  });
}

function checkUserExist(orgId: string, target: string) {
  return request({
    url: `users/targets/${target}/exist`,
    method: 'get',
    headers: {
      'x-org-id': orgId,
    },
  });
}

function searchPolicyTargets(
  orgId: string,
  service: string,
  targetType: TargetType,
  searchString: string
) {
  return request({
    url: `users/services/${service}/targets`,
    method: 'get',
    params: {
      searchString,
      targetType,
    },
    headers: {
      'x-org-id': orgId,
    },
  });
}

function getMipLabels(): AxiosPromise<any[]> {
  return request({
    url: `users/apps/mip/labels`,
    method: 'get',
  });
}

function searchTarget(
  searchString: string,
  orgId: string,
  service: string,
  targetType: TargetType,
  pagination?: Targets['pagination'],
  category?: number
) {
  const params: {
    searchString: string;
    pagination?: Targets['pagination'];
    category?: number;
  } = { searchString };
  if (pagination) {
    Object.assign(params, { ...pagination });
  }
  if (category) {
    // used for salesforce
    params.category = category;
  }
  return request({
    url: `users/services/${service}/targets`,
    method: 'get',
    params: {
      targetType,
      ...params,
    },
    headers: {
      'x-org-id': orgId,
    },
  });
}

function searchLocalAccountTargets(
  searchString: string,
  orgId: string,
  pagination?: Targets['pagination']
) {
  return request({
    url: `localAccounts/targetsTree/search`,
    method: 'post',
    data: {
      searchString,
      pagination,
    },
    headers: {
      'x-org-id': orgId,
    },
  });
}

function getUsersByGroupIds(
  groupIds: string[]
): AxiosPromise<{ users: TargetUser[]; error?: string }> {
  return request({
    url: `users/services/exchangeInline/targets/user/all`,
    method: 'post',
    data: {
      groupIds,
    },
  });
}

export default {
  getPolicyTargets,
  getLocalAccountTargets,
  checkUserExist,
  searchPolicyTargets,
  getMipLabels,
  searchTarget,
  searchLocalAccountTargets,
  getUsersByGroupIds,
};
